package com.vidaensupalabra.vsp.ventanas

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

import com.vidaensupalabra.vsp.ui.theme.VspBase
import com.vidaensupalabra.vsp.ui.theme.VspMarco
import com.vidaensupalabra.vsp.ui.theme.White

private const val CUENTA_AHORRO = "526-805680-49"
private const val NIT_IGLESIA = "901104161-3"
private const val CODIGO_SWIFT = "COLOCOBM"

@Composable
fun DonacionScreen(onBack: () -> Unit) {
    DonacionContent(onBack = onBack)
}

@Composable
private fun DonacionContent(onBack: () -> Unit) {
    Div(attrs = {
        style {
            width(100.percent)
            minHeight(100.vh)
            backgroundColor(VspBase)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            fontFamily("sans-serif")
        }
    }) {
        DonacionTopAppBar(onBack)

        Div(attrs = {
            style {
                width(100.percent)
                maxWidth(800.px)
                padding(16.px)
                boxSizing("border-box")
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(16.px)
            }
        }) {
            P(attrs = {
                style { color(White); fontSize(16.px); lineHeight("1.5"); margin(0.px) }
            }) {
                Text("Para realizar una donación de manera virtual, puedes hacerlo desde tu plataforma bancaria a nuestra cuenta de ahorro, usando los siguientes datos para la transacción:")
            }
            
            BankDetailsCard()
            ContactInfoSection()
        }
    }
}

@Composable
private fun DonacionTopAppBar(onBack: () -> Unit) {
    Header(attrs = {
        style {
            width(100.percent)
            height(90.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            position(Position.Relative)
        }
    }) {
        Button(attrs = {
            onClick { onBack() }
            style { position(Position.Absolute); left(16.px); backgroundColor(Color("transparent")); color(White); border(0.px); fontSize(24.px); cursor("pointer"); padding(8.px) }
        }) { Text("⬅️") }

        H2(attrs = { style { color(White); margin(0.px); fontSize(24.px); fontWeight("bold") } }) { Text("Donación") }
    }
}

@Composable
private fun BankDetailsCard() {
    Div(attrs = {
        style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); padding(8.px); width(100.percent); boxSizing("border-box"); flexWrap(FlexWrap.Wrap) }
    }) {
        Img(src = "drawable/logobancolombia.png", alt = "Logo de Bancolombia", attrs = {
            style { width(120.px); height(150.px); property("object-fit", "contain"); marginRight(16.px) }
        })
        
        Div(attrs = { style { flex(1); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column) } }) {
            DatosDonacionItem(label = "Cuenta de Ahorro Bancolombia:", value = CUENTA_AHORRO)
            DatosDonacionItem(label = "NIT:", value = NIT_IGLESIA)
            DatosDonacionItem(label = "Código Swift:", value = CODIGO_SWIFT)
        }
    }
}

@Composable
private fun DatosDonacionItem(label: String, value: String) {
    Div(attrs = { style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); margin(4.px, 0.px) } }) {
        Span(attrs = { style { color(VspMarco); fontSize(14.px) } }) { Text(label) }
        Span(attrs = { style { color(White); fontSize(18.px); fontWeight("bold"); property("user-select", "text") } }) { Text(value) }
    }
}

@Composable
private fun ContactInfoSection() {
    P(attrs = { style { color(White); fontSize(16.px); lineHeight("1.5") } }) {
        Text("Si deseas reportar tus donaciones para fines tributarios, envía copia de las transacciones que realices al correo: ")
        B { Text("contabilidad@vidaensupalabra.com") }
        Br()
        Br()
        Text("Por este mismo correo podrás solicitar tu certificación para fines tributarios.")
    }
}